// @flow
/* eslint-disable */
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import config from './config.js'
import store from './store/store.js'

const utils = {

isValidZIP(err) {
    return (v) => {
      if (v && utils.validZIP(v)) {
        return true
      } else {
        return err
      }
    }
  },

validZIP(zip) {
    const valid = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip)
    return valid
  },
isValidStateCode(err) {
    return (v) => {
      if (v && utils.validStateCode(v)) {
        return true
      } else {
        return err
      }
    }
  },
validStateCode(stateCode) {
    if (!stateCode) {
      return false
    }

    if (stateCode.hasOwnProperty('value')) {
      stateCode = stateCode.value
    }
    for (const v in utils.listofstates) {
      // console.log("validStateCode comparing: "+utils.listofstates[v].value+"  to "+stateCode)
      if (utils.listofstates[v].value === stateCode) { return true }
    }
    return false
  },


minLength(len, err) {
    return (v) => {
      if (!v) { // If v is null, it's okay!
        return true
      } else {
        return v.length >= len || err
      }
    }
  },
maxLength(len, err) {
    return (v) => {
      if (!v) { // If v is null, it's okay!
        return true
      } else {
        return v.length <= len || err
      }
    }
  },
required(err) {
    return (v) => {
      return !!v || err
    }
  },
phoneValidation(err) {
    return (value) => {
      if (!value || value == null) {
        return err
      }

      const len = value.length
      if (len !== 10) { // Expects XXXXXXXXXX
        return err // Not valid!
      } else {
        return true
      }
    }
  },
emailValidation(err) {
    return (v) => {
      if (!v) { // If v is null, it's okay!
        return true
      } else {
        const re = /\S+@\S+\.\S+/
        return re.test(v) || err
      }
    }
  },
validChars(re, err) {
    return (v) => {
      if (!v) { // If v is null, it's okay!
        return true
      } else {
        // var re = /reStr/
        return re.test(v) || err
      }
    }
  },
validNumber(err) {
    return (v) => {
      if (!v) { // If v is null, it's okay!
        return true
      } else {
        // var re = /reStr/
        return !isNaN(v) || err
      }
    }
  },
validateEmail(email) {
    // This will validate simple emails and may have false negatives,
    // but shouldn't have false positives.
    const re = /\S+@\S+\.\S+/
    return re.test(email)
  },
formatDate(date) {
    if (date) {
      // console.log(date)
      const d = date.toDate() // Convert from firebase Timestamp to Date
      return d.toLocaleDateString()
    } else {
      return 'No Date'
    }
  },
formatDateFromSeconds(seconds) {
    return utils.formatDateFromMilliseconds(seconds * 1000)
  },
  formatDateFromMilliseconds(millis) {
      if (millis) {
        // console.log(millis)
        const d = new Date(millis) // Convert from seconds to Date
        return d.toLocaleDateString()
      } else {
        return 'No Date'
      }
    },
deleteLocation(location) {
    // Delete a Naloxone Location -- return a promise
    var deleteLocation = config.getFunctions().httpsCallable('deleteLocation')
    return deleteLocation(
      {
        locationID: location.firebaseId
      }
    )

},
minutesToTime (num) {
    // Convert the nubmer of minutes to a time string like: 3:45 PM or Midnight

    if (num === 0 || num === 1440) {
        return "Midnight"
    }

    // Convert the minute of the day to a time.
    var hours = (num / 60);
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    let suffix = " AM"
    if (rhours > 12) {
        rhours -= 12
        suffix = " PM"
    } else if (rhours == 0) {
        rhours = 12
    }
    let padMin = ""
    if (rminutes < 10) padMin = "0"
    return rhours+":"+padMin+rminutes+suffix

},
removeFile(storagePath, fileName) {
    // Create a root reference
    console.log('Removing file: ' + storagePath + '  ' + fileName)
    const fileRef = firebase.storage().ref(storagePath).child(fileName)

    return fileRef.delete()
  },
uploadFile(file, storagePath, stateChangeFunction) {

    // Not used?
    throw new Error('uploadFile is never used?????')



    // Create a root reference
    const storageRef = firebase.storage().ref(storagePath)

    // Create a reference to 'images/mountains.jpg'
    const fileRef = storageRef.child(file.name)

    // Upload it
    const uploadTask = fileRef.put(file)

    // Listen for state changes, errors, and completion of the upload.
    const p = new Promise((resolve, reject) => {
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, stateChangeFunction, // or 'state_changed'
        (error) => {
          // A full list of error codes is available at
          // https://firebase.google.com/docs/storage/web/handle-errors
          console.log('UPLOAD ERROR: ' + error)
          switch (error.code) {
            case 'storage/unauthorized':
              // User doesn't have permission to access the object
              reject(error)
              break

            case 'storage/canceled':
              // User canceled the upload
              reject(error)
              break

            case 'storage/unknown':
              // Unknown error occurred, inspect error.serverResponse
              reject(error)
              break
          }
        }, () => {
          // Upload completed successfully, now we can get the download URL
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            console.log('File available at', downloadURL)
            resolve(downloadURL)
          })
        })
    }) // End of Promise
    return p
  },
uploadImgBlob(imgBlob, storagePath, fileName) {
    console.log('uploadBlob img: ' + storagePath + '   FILE:' + fileName + '   T:' + typeof(imgBlob))
    // Create a root reference
    const storageRef = firebase.storage().ref(storagePath)

    // Create a reference to 'images/mountains.jpg'
    const fileRef = storageRef.child(fileName)

    // Upload it
    const uploadTask = fileRef.put(imgBlob)

    return utils.monitorUpload(uploadTask)
  },
uploadBase64Img(base64Img, storagePath, fileName) {
    // Create a root reference
    const storageRef = firebase.storage().ref(storagePath)

    // Create a reference to 'images/mountains.jpg'
    const fileRef = storageRef.child(fileName)

    // Upload it
    const uploadTask = fileRef.putString(base64Img, 'data_url')

    return utils.monitorUpload(uploadTask)
  }
}


export default utils
